import React, { CSSProperties, FC, HTMLAttributes } from 'react';

export const ModalBody: FC<HTMLAttributes<HTMLDivElement>> = ({ children, ...htmlAttributes }) => {
  return (
    <div style={containerStyle} {...htmlAttributes}>
      {children}
    </div>
  );
};

const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
};

export const ModalHeading: FC<HTMLAttributes<HTMLHeadingElement>> = ({ children, ...htmlAttributes }) => {
  return (
    <h3 style={headerStyle} {...htmlAttributes}>
      {children}
    </h3>
  );
};

const headerStyle: CSSProperties = {
  textAlign: 'center',
};
